import { Box, Text } from '@chakra-ui/react'
import { ObjectContentNode } from '@helo/cms'

import { Skeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { TagDataType } from './tag.types'
import { TAG_LAYOUT, TagLayout } from './tagLayout'

interface TagRendererProps {
  isLoading?: boolean
  contentNode: ObjectContentNode
}

export const TagRenderer = ({
  contentNode,
  isLoading,
  ...props
}: TagRendererProps) => {
  const options = (contentNode.state ?? {}) as NonNullable<
    TagDataType['options']
  >
  const { size, _tooltip, hideLabel } = options
  const tag = contentNode.data as TagDataType['value']

  const valueSizeStyles = TagLayout.sizeStyles(size)
  const showSkeleton = !!isLoading

  const customStyles =
    contentNode.state?.styles && typeof contentNode.state.styles === 'object'
      ? contentNode.state.styles
      : {}

  return (
    <ConditionalTooltip isDisabled={showSkeleton} tooltipOptions={_tooltip}>
      <Skeleton
        isLoading={showSkeleton}
        w={valueSizeStyles.skeletonWidth}
        h={TagLayout.skeletonHeight(valueSizeStyles.fontSize)}
        rounded={TAG_LAYOUT.rounded}
      >
        <Box
          bg="presets.neutral.10"
          px={TAG_LAYOUT.paddingX}
          py={TAG_LAYOUT.paddingY}
          rounded={TAG_LAYOUT.rounded}
          {...props}
          {...customStyles}
        >
          <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            {!hideLabel && (
              <Text
                size={size}
                fontWeight="500"
                whiteSpace="nowrap"
              >{`${tag?.tagName}: `}</Text>
            )}
            <Text size={size} fontWeight="600" whiteSpace="nowrap">
              {tag?.tagValue}
            </Text>
          </div>
        </Box>
      </Skeleton>
    </ConditionalTooltip>
  )
}
